import * as types from 'model/actionTypes'
import { DictT, QuestionT } from 'shared/types/model'

export const receiveQuestionsLibrary = (questions: DictT<QuestionT>) => {
  return {
    type: types.RECEIVE_QUESTIONS_LIBRARY,
    questions
  }
}
